import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Fade } from 'react-bootstrap';
import closeIcon from './closeIcon.svg';
import './FloatingError.scss';

/**
 * Floating error control
 * @class FloatingError
 * @extends {Component}
 */
class FloatingError extends Component {
  state = { visible: true, };
  static propTypes = {
    /** Text of error message */
    messages: PropTypes.array,
    /** Amount of time to show the message */
    showDuration: PropTypes.number,
    /** Fade duration */
    fadeDuration: PropTypes.number,
    /** Whether the error box should be able to be dismissed by the user */
    dismissable: PropTypes.bool,
    /** Additional class name for the error box */
    floatingErrorStyle: PropTypes.string,
  };

  static defaultProps = {
    messages: ['Try again.',],
    showDuration: 10 * 1000,
    fadeDuration: 1 * 1000,
    dismissable: true,
    floatingErrorStyle: 'floating-error',
  };

  dismiss = () => {
    this.setState({ visible: false, });
  };

  componentDidMount() {
    if (this.props.showDuration > 0) {
      this.timeoutId = setTimeout(
        () => this.setState({ visible: false, }), this.props.showDuration
      );
    }
  };

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    return (
      <Fade in={this.state.visible}
        timeout={this.props.fadeDuration}
        unmountOnExit={true}
      >
        <div className='error-box-container'>
          <div className={this.props.floatingErrorStyle}>
            { this.props.dismissable && this.state.visible ? (
              <div className='close-button-area close-button' onClick={this.dismiss}>
                {/* <i className="fa fa-close" aria-hidden="true"></i> */}
                <img src={closeIcon} alt='close'/>
              </div>
            ) : null }
            <div className='floating-error-messages'>
              {this.props.messages.map( (error, index) => (
                <div className='error-box-message' key={index}>
                  {error}
                </div>
              ) )}
            </div>
          </div>
        </div>
      </Fade>
    );
  }
}

export default FloatingError;
